module.exports = __webpack_public_path__ + "static/img/wx.6d75c4b1.jpg";